/* ============================================================
   ordersPagerView — 4171ba09: pure derive model for the paginated
   order cabinets (customer OrdersPage + provider queue). Total /
   offset / limit in, one honest pager model out — page numbers,
   shown-range and prev/next flags — so both cabinets share the
   exact same pager math and it runs under `node --test`
   (tests/ordersPagerView.test.ts) as well as in the app bundle.
   ============================================================ */

export interface OrdersPagerView {
  /** 1-based page number. */
  page: number;
  /** Total page count; an empty list still counts as one (empty) page. */
  pageCount: number;
  /** 1-based ordinal of the first row shown (0 when the page is empty). */
  from: number;
  /** 1-based ordinal of the last row shown (0 when the page is empty). */
  to: number;
  hasPrev: boolean;
  hasNext: boolean;
}

export function buildOrdersPagerView(total: number, offset: number, limit: number): OrdersPagerView {
  const safeTotal = Math.max(0, Math.floor(total));
  const safeLimit = Math.max(1, Math.floor(limit));
  const safeOffset = Math.max(0, Math.floor(offset));

  const pageCount = Math.max(1, Math.ceil(safeTotal / safeLimit));
  const page = Math.floor(safeOffset / safeLimit) + 1;
  const from = safeTotal === 0 ? 0 : safeOffset + 1;
  const to = Math.min(safeOffset + safeLimit, safeTotal);

  return {
    page,
    pageCount,
    from,
    to,
    hasPrev: safeOffset > 0,
    hasNext: safeOffset + safeLimit < safeTotal,
  };
}
